// Phone number formatting function for US numbers (10 digits)
export const formatPhoneNumber = (value) => {
  if (!value) return '';

  // Remove all non-digits
  let phoneNumber = value.replace(/\D/g, '');

  // If it starts with '1' and we have more than 10 digits, or it's a leading 1, strip it
  // This handles the user typing 1 at the start of a US number
  if (phoneNumber.startsWith('1') && phoneNumber.length > 10) {
    phoneNumber = phoneNumber.slice(1);
  } else if (phoneNumber === '1') {
      // If user literally just typed '1', we can either keep it or strip it.
      // Usually better to strip it if we only want 10 digits and they typed the country code.
      return '';
  }

  // Maximum 10 digits for US numbers
  phoneNumber = phoneNumber.slice(0, 10);

  // If empty, return empty string
  if (phoneNumber.length === 0) return '';

  // 1-2 digits: return as is
  if (phoneNumber.length <= 2) {
    return phoneNumber;
  }

  // 3-6 digits: (XXX) XXX
  if (phoneNumber.length >= 3 && phoneNumber.length <= 6) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // 7-10 digits: (XXX) XXX-XXXX
  if (phoneNumber.length >= 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }

  return phoneNumber;
};

// Phone number validation function
export const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber || !phoneNumber.trim()) {
    return "Phone number is required";
  }

  const phoneDigits = phoneNumber.replace(/\D/g, '');
  
  if (phoneDigits.length < 10) {
    return "Phone number must be 10 digits";
  }
  
  // Basic validation that it looks like (XXX) XXX-XXXX or simple 10 digits
  const phoneRegex = /^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/;
  if (!phoneRegex.test(phoneNumber) && phoneDigits.length === 10) {
      // If it's exactly 10 digits but failed regex, it might be due to user-entered formatting
      // but formatPhoneNumber should have handled it.
  } else if (!phoneRegex.test(phoneNumber)) {
    return "Please enter a valid 10-digit phone number (e.g., (555) 123-4567)";
  }
  
  return null; // No error
}; 